// table-column — default skin module (RUN-407: native table redesign)
// Column is projected into native <th> elements in run-table's shadow DOM via
// manual slot assignment. role="columnheader", sort indicators, and sort ARIA
// are now rendered by run-table's skin on the <th> element. This skin provides
// a content pass-through for the column's light-DOM label.

export const styles = `
  :host {
    display: contents;
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<slot></slot>`;
}
